import React, { useState } from 'react'
import { useSendEmailV3Mutation } from '../api/v2/emailsV3'
import { useMyContext } from '../context/context'
import useHistoryCustom from '../hooks/useHistoryCustom'
import ROUTES from '../services/routes'
import Button from '../shared/form/button'
import Input from '../shared/form/input'
import MessageError from '../shared/message.error'
import Success from '../shared/success'

const PasswordForgot = () => {
  const history = useHistoryCustom()
  const { myContext } = useMyContext()

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const [sendEmailV3] = useSendEmailV3Mutation()

  const onSubmit = async event => {
    event.preventDefault()
    if (!email) return
    setLoading(true)
    setError('')
    setSuccess(false)

    try {
      await sendEmailV3({ ...myContext, actionId: 3, userId: null, email }).unwrap()
      setSuccess(true)
      setEmail('')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ padding: '20px 0' }} className="form">
      <form onSubmit={onSubmit} className="field">
        <Input value={email} onChange={setEmail} type="email" label="Email" required focus isForm />
        <MessageError message={error} />
        <Success isSuccess={success} message="Vous allez recevoir un email pour créer un nouveau mot de passe" />
        <Button style={{ width: '100%' }} label="Réinitialiser" loading={loading} submit />
      </form>

      <div className="is-divider" data-content="J'ai retrouvé mon mot de passe" />
      <Button style={{ width: '100%' }} label="Me connecter" onClick={() => history.push(ROUTES.LOGIN)} />
    </div>
  )
}

export default PasswordForgot
